import React, { useState } from "react";
import _environment from "../../../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  user:
    | {
    profile_image_url?: string | null;
  }
    | null
    | undefined;
  className?: string;
}

const UserImage = ({ className, user, ...props }: Props) => {
  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [src, setSrc] = useState<string>(
    user?.profile_image_url || _environment.assets.userPlaceholder,
  );

  const [error, setError] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Handle error image
   * @function
   */
  const onError = () => {
    if (!error) {
      setSrc(_environment.assets.userPlaceholder);
      setError(true);
    }
  };

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return <div className="img-profile rounded-circle"
              style={{ backgroundImage: `url(${src})` }}
              onError={onError}/>;
};
export default UserImage;
